<template>
  <v-row>
    <v-dialog class="mx-0" v-model="dialog" persistent max-width="700px">
      <template v-slot:activator="{ on, attrs }">
        <v-row>
          <v-col cols="12" class="d-flex justify-end">
            <v-btn text large icon v-bind="attrs" v-on="on">
              <v-icon medium color="red lighten-1" class="mb-3"> mdi-plus-circle </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </template>
      <v-card>
        <v-row class="mx-0">
          <v-col cols="12" class="d-flex justify-center">
            <v-card-title>
              <span class="headline">Cadastro de Categoria</span>
            </v-card-title>
          </v-col>
        </v-row>
        <v-card-text>
          <v-form ref="new_provider_form">
            <v-row>
              <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                <v-text-field
                  v-model="$v.form.category_name.$model"
                  label="Nome da Categoria*"
                  color="red lighten-1"
                  required
                  :error-messages="errors.data.category_name"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" text @click="closeModal()"> Fechar </v-btn>
          <v-btn color="black" text @click="storeCategory()"> Salvar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { mask } from 'vue-the-mask'
import { mapActions } from 'vuex'

export default {
  name: 'NewAcquisitionCategory',
  directives: { mask },

  data: () => ({
    dialog: false,

    form: {
      category_name: '',
    },
    errors: {
      messages: {
        required: 'O campo e obrigatorio',
      },
      data: {
        category_name: [],
      },
    },
  }),
  validations: {
    form: {
      category_name: { required },
    },
  },
  methods: {
    ...mapActions('ui', ['ActionSetLoading']),
    ...mapActions('acquisitions', ['ActionStoreAcquisitionCategory']),

    async storeCategory() {
      this.ActionSetLoading(true)

      try {
        this.$v.$touch()
        Object.keys(this.errors.data).forEach((key) => {
          this.errorMensage(key)
        })
        if (!this.$v.$invalid) {
          let treated_form = new FormData()
          treated_form.append('category_name', this.form.category_name)

          await this.ActionStoreAcquisitionCategory(treated_form)
          this.$swal({
            icon: 'success',
            title: 'Cadastrado',
            text: 'Categoria cadastrada com sucesso',
          })

          this.closeModal()
        }
      } catch (error) {
        if (error.body) {
          if (error.status != 422) {
            this.$swal({
              icon: 'error',
              title: 'Erro',
              text: error.body.message,
            })
          }
          if (error.body.errors) {
            Object.keys(error.body.errors).map((key) => {
              this.errors.data[key] = error.body.errors[key]
            })
          }
        }
      }

      this.ActionSetLoading(false)
    },

    closeModal() {
      this.$refs.new_provider_form.reset()
      this.dialog = false
    },

    errorMensage(key) {
      const errors = []
      if (key == 'id') return
      if (!this.$v.form[key].$dirty) return errors

      if (this.$v.form[key].required !== undefined)
        !this.$v.form[key].required && errors.push(this.errors.messages.required)

      if (this.$v.form[key].minLength !== undefined)
        !this.$v.form[key].minLength &&
          errors.push(this.errors.messages.minLength(this.$v.form[key].$params.minLength.min))

      if (this.$v.form[key].maxLength !== undefined)
        !this.$v.form[key].maxLength &&
          errors.push(this.errors.messages.maxLength(this.$v.form[key].$params.maxLength.max))

      if (this.$v.form[key].email !== undefined)
        !this.$v.form[key].email && errors.push(this.errors.messages.email)

      this.errors.data[key] = errors
    },
  },
}
</script>